import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class SalesByCustomerResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                sales_by_customer: {
                    rows: [
                        { customer: "Supermercados Los Andes", net_sales: "24850000.00", mix: "35.20", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "5980.00", boxes_mix: "34.90", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { customer: "Panadería Central", net_sales: "16920000.00", mix: "24.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "4120.00", boxes_mix: "24.05", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { customer: "Distribuidora del Norte", net_sales: "12680000.00", mix: "18.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "3055.00", boxes_mix: "17.83", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { customer: "Almacén Don José", net_sales: "8460000.00", mix: "12.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "2010.00", boxes_mix: "11.73", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { customer: "Comercial San Martín", net_sales: "4930000.00", mix: "7.00", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "1195.00", boxes_mix: "6.98", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                        { customer: "Kiosco La Esquina", net_sales: "2610000.00", mix: "3.80", fulfillment: null, projected_fulfillment: null, fulfillment_vs_budget: null, projected_vs_budget: null, net_boxes: "680.00", boxes_mix: "4.51", boxes_fulfillment: null, boxes_projected_fulfillment: null, boxes_fulfillment_vs_budget: null, boxes_projected_vs_budget: null },
                    ],
                    total: { customer: null, net_sales: "70450000.00", mix: "100.00", fulfillment: "62.90", projected_fulfillment: "78.70", fulfillment_vs_budget: "-37.10", projected_vs_budget: "-21.30", net_boxes: "17040.00", boxes_mix: "100.00", boxes_fulfillment: "61.20", boxes_projected_fulfillment: "76.60", boxes_fulfillment_vs_budget: "-38.80", boxes_projected_vs_budget: "-23.40" },
                },
            },
            errors: [],
        };
    }

    salesByCustomer() {
        const salesByCustomer = this.content().sales_by_customer;
        return {
            rows: salesByCustomer.rows.map((row) => this._adaptRow(row)),
            total: this._adaptRow(salesByCustomer.total),
        };
    }

    _adaptRow(row) {
        return {
            group: row.customer,
            netSales: this._toNumber(row.net_sales),
            mix: this._toNumber(row.mix),
            fulfillment: this._toNumber(row.fulfillment),
            projectedFulfillment: this._toNumber(row.projected_fulfillment),
            fulfillmentVsBudget: this._toNumber(row.fulfillment_vs_budget),
            projectedVsBudget: this._toNumber(row.projected_vs_budget),
            netBoxes: this._toNumber(row.net_boxes),
            boxesMix: this._toNumber(row.boxes_mix),
            boxesFulfillment: this._toNumber(row.boxes_fulfillment),
            boxesProjectedFulfillment: this._toNumber(row.boxes_projected_fulfillment),
            boxesFulfillmentVsBudget: this._toNumber(row.boxes_fulfillment_vs_budget),
            boxesProjectedVsBudget: this._toNumber(row.boxes_projected_vs_budget),
        };
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
